<template>
  <div class="all-section-area">
    <MainHeader />
    <main class="main-content-wrap">
      <div class="d-flex justify-content-between align-items-center">
        <PageTitle mainTitle="Lista de Utilizadores" pageTitle="Utilizadores" />
        <button v-if="isSuperAdmin" class="btn btn-primary mb-4 me-4" data-bs-toggle="modal"
          data-bs-target="#exampleModal" @click="selectedUser = null">
          Adicionar Utilizador
        </button>
      </div>

      <ContactList ref="contactList" @edit-user="handleEditUser" @confirm-delete="prepareDelete" />
      <ContactModal :editUserData="selectedUser" @user-saved="refreshList" />
      <DeleteConfirmationModal ref="deleteModal" :itemLabel="userToDelete?.email" :loading="deleteLoading"
        @confirm="handleDeleteUser" />

      <div class="flex-grow-1"></div>
      <FooterArea />
    </main>
  </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader';
import PageTitle from '../Common/PageTitle';
import ContactList from '../ContactList/ContactList';
import ContactModal from '../ContactList/ContactModal';
import DeleteConfirmationModal from '../Common/DeleteConfirmationModal';
import FooterArea from '../Layouts/FooterArea';
import authService from '../../services/authService';
import usersService from '../../services/usersService';
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.js';

export default {
  name: 'ContactListPage',
  components: {
    MainHeader,
    PageTitle,
    ContactList,
    ContactModal,
    DeleteConfirmationModal,
    FooterArea,
  },
  data() {
    return {
      selectedUser: null,
      userToDelete: null,
      deleteLoading: false,
    };
  },
  computed: {
    isSuperAdmin() {
      const user = authService.getUser();
      return user?.role === 'SUPERADMIN';
    },
  },
  methods: {
    handleEditUser(user) {
      this.selectedUser = user;
      const modal = new bootstrap.Modal(document.getElementById('exampleModal'));
      modal.show();
    },
    prepareDelete(user) {
      this.userToDelete = user;
      const modal = new bootstrap.Modal(document.getElementById('deleteConfirmationModal'));
      modal.show();
    },
    async handleDeleteUser() {
      if (!this.userToDelete) return;

      this.deleteLoading = true;
      try {
        await usersService.delete(this.userToDelete.id);
        this.refreshList();

        const modal = bootstrap.Modal.getInstance(document.getElementById('deleteConfirmationModal'));
        if (modal) modal.hide();

        this.userToDelete = null;
      } catch (err) {
        alert(err.response?.data?.message || 'Erro ao remover utilizador');
      } finally {
        this.deleteLoading = false;
      }
    },
    refreshList() {
      this.$refs.contactList.loadUsers();
    },
  },
  mounted() {
    document.body.classList.add('body-bg-f8faff');
  },
};
</script>
